import React from 'react';
import firstPost from '../../assets/111-1.png'
import secondPost from '../../assets/Insta poster - 2-1.png'
import thirdPost from '../../assets/Solo Intro 2.png'
import fourthPost from '../../assets/Insta poster.png'

const InstagramSection = () => {

    return (
        <div>
            <div className="container halfGrid">
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <div className='styled__heading gradient__animation' style={{ display: "flex", alignItems: "center" }}>
                        <h1 className='primary__heading' style={{ fontSize: "25px" }}>━━  Learn</h1>
                    </div>
                    <h1 className='primary__heading accent__heading primary__heading__gap' style={{ color: "gray", marginBottom: "3rem", lineHeight: "58px" }}>Developers
                        <br />tips and tricks</h1>
                    <p className='responsive' style={{ marginBottom: "2rem" }}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis nemo debitis distinctio, cum eligendi voluptatum neque nam aut in, perferendis accusamus architecto odit dolores repellat placeat reprehenderit praesentium culpa eos!</p>
                    <div className='responsive'><a href="https://www.instagram.com/rokannprogramming/" className='outline__link'>❤️ Explore on instagram</a></div>
                </div>
                <div className="instPostImages">
                    <div className="sliderWrapper">
                        <span className='sliderImage'>
                            <img src={firstPost} alt="" />
                            <img src={secondPost} alt="" />
                            <img src={thirdPost} alt="" />
                            <img src={fourthPost} alt="" />
                        </span>
                    </div>
                    <div className="progressBar"></div>
                </div>
            </div>
        </div>
    );
};

export default InstagramSection;